<nav id="sidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" (click)="toggleNav()">&times;</a>
    <div class="link-container"><img src="../assets/images/exl_logo_rgb_wht_rev.png" alt="EXL" class="brandExl" />
    
    <a id="sidenav-home" href="javascript:void(0);" routerLink="/home">
      <i class="pi pi-home"></i>
      Home
    </a>
    </div>
</nav>
